import { observer } from "mobx-react";
import { useCallback, useState } from "react";
import useTranslation from "../../../../../../translation/hooks/translation-hook";
import useNavigationBlocker from "../../../../../../hooks/navigation-blocker-hook";
import EditorPageLayout from "../../../../../../components/layouts/editor-page/editor-page-layout";
import ListLayout from "../../../../../../components/layouts/list-layout/list-layout";
import ControlGroupWithPreview from "../../../../../../components/layouts/control-group-with-preview/control-group-with-preview";
import EstimatedDeliveryPreview from '../../../../../../images/previews/estimated-delivery.svg';
import { FormField } from "../../../../../../components/form-field/form-field";
import TranslationRichTextEditor from "../../../../../../translation/translation-rich-text-editor/translation-rich-text-editor";
import { TRACKING_PORTAL_TRANSLATION_KEYS } from "../../constants";
import { ConfirmModal } from "../../../../../../components/modal/components/confirm-modal/confirm-modal";
import TranslationInput from "../../../../../../translation/translation-input/translation-input";

const GeneralTextsEditor: React.FC = observer(() => {
    const [isShowUnsaved, setIsShowUnsaved] = useState(false);

    const {
        hasChanges: hasTranslationChanges,
        discardChanges: translationsDiscardChanges,
        save: saveTranslations
    } = useTranslation();

    const hasChanges = () => {
        return hasTranslationChanges();
    }

    const { retryNavigation, unblockNavigation } = useNavigationBlocker(
        () => hasChanges(),
        useCallback(() => setIsShowUnsaved(true), [setIsShowUnsaved])
    );

    const discardChanges = () => {
        translationsDiscardChanges();
    }

    const onSaveClicked = () => {
        const promised = [];

        if (hasTranslationChanges()) {
            promised.push(
                saveTranslations()
            );
        }

        Promise.all(promised).then(() => {
            unblockNavigation();
        })
    }


    return (
        <>
            <EditorPageLayout
                toolbar={{
                    saveButton: {
                        hasChanges: hasChanges(),
                        disabled: !hasChanges(),
                        onClick: onSaveClicked
                    }
                }}
            >
                <ControlGroupWithPreview hasTopBorder={false} preview={<img src={EstimatedDeliveryPreview} alt="" />}>
                    <ListLayout>
                        <FormField label="Estimated Delivery Date Description">
                            <TranslationRichTextEditor minHeight={250} translationKey={TRACKING_PORTAL_TRANSLATION_KEYS.ESTIMATED_DELIVERY_DESCRIPTION} />
                        </FormField>
                        
                        <FormField label="Last update">
                            <TranslationInput translationKey={TRACKING_PORTAL_TRANSLATION_KEYS.LATEST_UPDATE} />
                        </FormField>
                        
                        <FormField label="Details">
                            <TranslationInput translationKey={TRACKING_PORTAL_TRANSLATION_KEYS.DETAILS} />
                        </FormField>
                        
                        <FormField label="Shipment content">
                            <TranslationInput translationKey={TRACKING_PORTAL_TRANSLATION_KEYS.SHIPMENT_CONTENT} />
                        </FormField>
                        
                        <FormField label="History">
                            <TranslationInput translationKey={TRACKING_PORTAL_TRANSLATION_KEYS.HISTORY} />
                        </FormField>
                    </ListLayout>
                </ControlGroupWithPreview>
            </EditorPageLayout>

            {isShowUnsaved &&
                <ConfirmModal
                    cancelButton={{
                        title: 'Cancel',
                        onClick: () => setIsShowUnsaved(false)
                    }}
                    okButton={{
                        title: 'Discard',
                        onClick: () => {
                            discardChanges();
                            setIsShowUnsaved(false);
                            retryNavigation();
                        }
                    }}
                />
            }
        </>
    );
});

export default GeneralTextsEditor;